/**
 * TBB Newsletter Popup helpers — loaded WITHOUT defer (intentionally),
 * so the success-reopen check below runs before the deferred
 * newsletter-popup.js engine reads its localStorage gate.
 *
 * Two jobs:
 *
 * 1. SUCCESS REOPEN. Shopify posts the customer form to /contact and
 *    redirects back with `?customer_posted=true#tbb-nlp-form` (the hash
 *    is OUR form id, so footer newsletter posts don't trigger this).
 *    The popup engine normally suppresses re-display via the
 *    `newsletterLastViewed` localStorage key — which would hide the
 *    "you're in" confirmation. Clearing the key lets the engine reopen
 *    the popup, whose template now renders the success state.
 *
 * 2. TAG COMPOSITION. The Shopify customer form persists email + tags
 *    natively but has NO supported phone field, so on submit we fold the
 *    SMS opt-in into the hidden contact[tags] input:
 *      newsletter                      — always
 *      sms-opt-in, phone:<digits>      — only when the text box is
 *                                        checked and a phone was entered
 *    Klaviyo / Flow pick the tag + phone up from the customer record.
 *    Commas are stripped from the phone so it can't split into bogus tags.
 */
(function () {
  'use strict';

  if (
    window.location.hash === '#tbb-nlp-form' &&
    window.location.search.indexOf('customer_posted=true') > -1
  ) {
    try {
      window.localStorage.removeItem('newsletterLastViewed');
    } catch (e) {
      /* private mode etc. — popup just stays closed; harmless */
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('tbb-nlp-form')) return;

    var tagsInput = form.querySelector('[data-tbb-nlp-tags]');
    if (!tagsInput) return;

    var tags = ['newsletter'];
    var smsBox = form.querySelector('[data-tbb-nlp-sms]');
    var phoneInput = form.querySelector('[data-tbb-nlp-phone]');
    if (smsBox && smsBox.checked && phoneInput) {
      var phone = phoneInput.value.replace(/[^0-9+]/g, '');
      if (phone) {
        tags.push('sms-opt-in');
        tags.push('phone:' + phone);
      }
    }
    tagsInput.value = tags.join(',');
  });
})();
